import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../../lib/api";

// B12 public page for a shared document link. Viewing does not use a download; the download button does.
export default function ShareDownload() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/comms/public/shares/${token}`).then((r) => setInfo(r.data)).catch((e) => setErr(e?.response?.data?.detail?.message || "This link is not valid.")); }, [token]);
  const href = `${process.env.REACT_APP_BACKEND_URL || ""}/api/comms/public/shares/${encodeURIComponent(token)}/download`;
  return (
    <main className="min-h-screen bg-erf-cream flex items-center justify-center p-4" data-testid="share-page">
      <div className="w-full max-w-md rounded border border-erf-borderCream bg-white p-6 space-y-3">
        <h1 className="font-heading text-xl">Shared document</h1>
        {err && <p role="alert" className="text-sm text-red-800" data-testid="share-error">{err}</p>}
        {info && <>
          <p data-testid="share-file">{info.file_name} · version {info.version}</p>
          <p className="text-sm" data-testid="share-limits">{info.uses_left} download(s) left · expires {info.expires_at.slice(0, 16).replace("T", " ")} UTC</p>
          <a href={href} className="inline-flex min-h-[44px] items-center px-4 rounded bg-erf-navy text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2" data-testid="share-download">Download</a>
        </>}
      </div>
    </main>
  );
}
